(ns app.front.view.group.reporting.assessment
  (:require [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.content-switcher :as content-switcher]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.reporting.common :as reporting-common]
            [app.front.view.group.reporting.config :as gar-config]
            [app.front.view.group.reporting.permit-package :as pp]
            [app.front.view.group.reporting.table :as gar-table]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]
            [schema.core :as s]))


(def new-reports-states #{:assessment-report.integration-state/new
                          :assessment-report.integration-state/in-progress})


(def failed-reports-states #{:assessment-report.integration-state/failed})


(def completed-reports-states #{:assessment-report.integration-state/complete
                                :assessment-report.integration-state/skipped})


(rf/reg-event-fx ::init
  (fn [_ [_ group-id]]
    {:fx (concat [[:dispatch [::reporting-common/fetch-group group-id]]
                  [:dispatch [::fetch-assessment-reports
                              group-id
                              new-reports-states
                              {:from  0
                               :limit 100}]]
                  [:dispatch [::fetch-assessment-reports group-id
                              failed-reports-states
                              {:sort  {:key       :entity/created
                                       :direction :desc}
                               :from  0
                               :limit 30}]]]
                 (->> [new-reports-states
                       failed-reports-states
                       completed-reports-states]
                      (map (fn [states]
                             [:dispatch [::fetch-assessment-report-count group-id states]]))))}))


(rf/reg-event-fx ::fetch-assessment-report-count
  (fn [_ [_ group-id states]]
    {:comm/command {:command    :reports/group-assessment-report-count
                    :data       {:group-id group-id
                                 :states   states}
                    :on-success [::fetch-assessment-report-count.success states]}}))


(rf/reg-event-db ::fetch-assessment-report-count.success
  (fn [db [_ states _ {:keys [total]}]]
    (assoc-in db [::total states] total)))


(rf/reg-event-fx ::fetch-assessment-reports
  (fn [{:keys [db]} [_ group-id states opts]]
    {:comm/command {:command          :reports/group-assessment-reports
                    :data             (merge {:group-id group-id
                                              :states   states}
                                             opts)
                    :on-success       [::fetch-assessment-reports.success group-id states]
                    :finally-dispatch [::fetch-assessment-reports.done states]}
     :db           (assoc-in db [::fetch-loading states] true)}))


(rf/reg-event-fx ::fetch-assessment-reports.success
  (fn [{:keys [db]} [_ group-id states status reports]]
    {:fx [[:dispatch [::entities/merge-entity-db status (->> reports
                                                             (map #(dissoc % :permit-data))
                                                             du/entities->entity-db)]]
          [:dispatch [::fetch-assessment-report-count group-id states]]]
     :db (->> reports
              (map (juxt :db/id :permit-data))
              (update db ::assessment-permits (fnil into {})))}))


(rf/reg-event-fx ::fetch-assessment-reports.done
  (fn [{:keys [db]} [_ states]]
    {:db (assoc-in db [::fetch-loading states] false)}))


(defn set-to-in-progress [db report-ids]
  (reduce (fn [new-db id]
            (assoc-in new-db
                      [::entities/entity-db id :assessment-report/integration-state]
                      :assessment-report.integration-state/in-progress))
          db
          report-ids))

(rf/reg-event-fx ::send-assessment-reports
  (fn [{:keys [db]} [_ report-ids]]
    {:comm/command {:command    :reports/send-assessment-reports
                    :data       {:report-ids report-ids}
                    :on-success [::entities/apply-changes]}
     :db           (set-to-in-progress db report-ids)}))

(rf/reg-event-fx ::delete-assessment-reports
  (fn [{:keys [db]} [_ report-ids]]
    {:comm/command {:command    :reports/delete-assessment-reports
                    :data       {:report-ids report-ids}
                    :on-success [::entities/apply-changes]}
     :db           (set-to-in-progress db report-ids)}))


(rf/reg-sub ::loading?
  (fn [db [_ states-key]]
    (boolean (get-in db [::fetch-loading states-key]))))


(rf/reg-sub ::assessment-permits :-> ::assessment-permits)


(rf/reg-sub ::assessment-permits-for-ids
  :<- [::assessment-permits]
  (fn [permits [_ ids]]
    (select-keys permits ids)))


(rf/reg-sub ::assessment-reports
  :<- [::entities/context]
  :<- [::gas/group-id]
  (fn [[ctx group-id] _]
    (->> (entities/find-entities ctx {:entity/type   :entity.type/assessment-report
                                      :entity/parent group-id})
         (sort-by :entity/created))))


(rf/reg-sub ::new-assessment-reports
  :<- [::assessment-reports]
  (fn [reports _]
    (->> reports
         (filter #(->> % :assessment-report/integration-state (contains? new-reports-states))))))


(rf/reg-sub ::failed-assessment-reports
  :<- [::assessment-reports]
  (fn [reports _]
    (->> reports
         (filter #(-> % :assessment-report/integration-state (= :assessment-report.integration-state/failed))))))


(rf/reg-sub ::completed-assessment-reports
  :<- [::assessment-reports]
  (fn [reports _]
    (->> reports
         (filter #(-> % :assessment-report/integration-state completed-reports-states))
         (sort-by :assessment-report/reported >))))


(rf/reg-sub ::total-reports
  (fn [db [_ states]]
    (get-in db [::total states] 0)))


(defn report-section [{:keys [tr title-key button-key reports loading? total sendable?
                              disable-selection? action deletable? initial-load-key]}]
  (r/with-let [*selected-reports (r/atom #{})]
    (let [total       (max (or total 0) (count reports))
          remaining   (- total (count reports))
          permit-data (<sub [::assessment-permits-for-ids (mapv :db/id reports)])
          sel-count   (count @*selected-reports)
          disabled?   (zero? sel-count)
          errors-sel? (->> @*selected-reports
                           (some #(-> (get permit-data %) :errors seq))
                           boolean)
          more-avail? (and action (pos? remaining))]
      [:div.mt-8
       [:div.flex.flex-row.flex-1.justify-between.items-center.mb-2
        [:h3.mb-0 (str (tr [title-key]) " (" total ")")]
        [:div.flex-0
         (when deletable?
           [ui/modal-confirmation-button
            {:id                  "delete-reports"
             :disabled?           disabled?
             :trigger-button-opts {:kind       :secondary
                                   :class-name "mr-2"
                                   :icon       i/trash}
             :tr                  tr
             :trigger-button-text (tr [:assessment-reporting/delete] [sel-count])
             :on-yes-click        #(>evt [::delete-assessment-reports @*selected-reports])}
            [:div (tr [:assessment-reporting/delete-confirm] [sel-count])]])
         (when sendable?
           (cc/button {:icon     i/upload
                       :kind     :primary
                       :disabled (or disabled? errors-sel?)
                       :title    (if errors-sel?
                                   (tr [:assessment-reporting/warn-invalid])
                                   "")
                       :on-click (fn [_]
                                   (>evt [::send-assessment-reports @*selected-reports])
                                   (reset! *selected-reports #{}))}
                      (tr [button-key]
                          [sel-count])))]]
       (cond
         loading?
         (cc/data-table-skeleton)

         (seq reports)
         [gar-table/report-table (name title-key) tr reports permit-data (when-not disable-selection?
                                                                           *selected-reports)]

         (and initial-load-key
              (zero? (count reports))
              more-avail?)
         (cc/button {:icon     i/refresh
                     :kind     :ghost
                     :on-click #(>evt action)}
                    (tr [initial-load-key]))

         :else
         [:div (tr [:assessment-reporting/no-reports])])

       (when more-avail?
         [:div.bx--row>div.bx--col-xs-12.flex.justify-center
          [:div.cursor-pointer.p-4.flex.flex-col.items-center
           {:on-click #(>evt action)}
           (cc/icon {:icon        i/refresh
                     :class-name  "mb-4"
                     :description (tr [:dashboard-search/load-more] [remaining])})
           [:span.semibold (tr [:dashboard-search/load-more] [remaining])]]])])))

(rf/reg-sub ::has-reporting-partner?
  :<- [::gas/group]
  (fn [group]
    (-> group :group/assessment-reporting-partner some?)))

(rf/reg-sub ::permit-package-submission-enabled?
  :<- [::gas/group]
  (fn [group]
    (-> group
        :group/features
        (contains? :group.feature/permit-package-submission))))

(rf/reg-sub ::view-choices
  :<- [::has-reporting-partner?]
  :<- [::permit-package-submission-enabled?]
  (fn [[has-partner? permit-submissions?]]
    (->> [(when has-partner?
            :reports)
          (when (and has-partner? permit-submissions?)
            :submissions)
          :config]
         (remove nil?)
         vec)))

(rf/reg-sub ::view-labels
  :<- [:tr]
  :<- [::gas/group]
  (fn [[tr group]]
    {:reports     (tr [:assessment-reporting/reports-title]
                      [(:group/assessment-reporting-partner group)])
     :submissions (tr [:permit-package-submission/submissions-title])
     :config      (tr [:assessment-reporting/configuration])}))

(rf/reg-event-fx ::on-change-view
  (fn [{:keys [db]} [_ group-id view]]
    (cond-> {:db (assoc db ::selected-view view)
             :fx []}
      (= view :submissions)
      (update :fx into [[:dispatch [::pp/show-permit-package-submissions-for-group group-id]]]))))

(rf/reg-sub ::selected-view
  :-> ::selected-view)

(rf/reg-sub ::current-view
  :<- [::view-choices]
  :<- [::selected-view]
  (fn [[choices selected]]
    (or selected
        (first choices))))

(defn view [match]
  (let [tr                (<sub [:tr])
        group             (<sub [::gas/group])
        new-reports       (<sub [::new-assessment-reports])
        failed-reports    (<sub [::failed-assessment-reports])
        completed-reports (<sub [::completed-assessment-reports])
        failed-count      (<sub [::total-reports failed-reports-states])
        views             (<sub [::view-choices])
        current-view      (<sub [::current-view])]
    [reporting-common/report-page
     match
     tr
     [acommon/section {}
      (when (< 1 (count views))
        [:<>
         [:div.mb-8
          [content-switcher/content-switcher
           {:items     views
            :val->str  (<sub [::view-labels])
            :current   current-view
            :on-change #(>evt [::on-change-view (:db/id group) %])}]]])

      (case current-view
        :config
        (if (seq group)
          ^{:key (str "assessment-config-" (:db/id group) (:entity/version group))}
          [gar-config/assessment-config tr group]
          (cc/skeleton-text))

        :submissions
        [pp/submissions-view (:db/id group)]

        ;; else
        [:<>
         [report-section {:tr         tr
                          :title-key  :assessment-reporting/new-reports
                          :button-key :assessment-reporting/send
                          :sendable?  true
                          :deletable? true
                          :total      (<sub [::total-reports new-reports-states])
                          :loading?   (<sub [::loading? new-reports-states])
                          :reports    new-reports
                          :action     [::fetch-assessment-reports
                                       (:db/id group)
                                       new-reports-states
                                       {:from  (count new-reports)
                                        :limit 100}]}]

         (when (or (pos? failed-count)
                   (seq failed-reports))
           [report-section {:tr         tr
                            :title-key  :assessment-reporting/failed-reports
                            :button-key :assessment-reporting/resend
                            :sendable?  true
                            :deletable? true
                            :total      (if (> (count failed-reports) failed-count)
                                          (count failed-reports)
                                          failed-count)
                            :loading?   (<sub [::loading? failed-reports-states])
                            :reports    failed-reports
                            :action     [::fetch-assessment-reports
                                         (:db/id group)
                                         failed-reports-states
                                         {:sort  {:key       :entity/created
                                                  :direction :desc}
                                          :from  (count failed-reports)
                                          :limit 30}]}])

         [report-section {:tr                 tr
                          :title-key          :assessment-reporting/completed-reports
                          :initial-load-key   :assessment-reporting/load-completed
                          :reports            completed-reports
                          :total              (<sub [::total-reports completed-reports-states])
                          :loading?           (<sub [::loading? completed-reports-states])
                          :disable-selection? true
                          :action             [::fetch-assessment-reports
                                               (:db/id group)
                                               completed-reports-states
                                               {:sort  {:key       :assessment-report/reported
                                                        :direction :desc}
                                                :from  (count completed-reports)
                                                :limit 20}]}]])]]))


(def route
  {:name        :view/group.reporting.assessment
   :view        view
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [{{:keys [group-id]} :path}]
                                (>evt [::init group-id]))}]})
